export function toSentenceCase(paragraph: string): string {
  // Convert the entire paragraph to lowercase first to ensure consistency.
  paragraph = paragraph.toLowerCase();

  return paragraph.replace(/(^\s*\w{1}|\.\s*\w{1})/g, function (match: string): string {
    // For each match found, convert it to uppercase.
    return match.toUpperCase();
  });
}

export function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
